const sidebarMenu = [
  // Hiding Dashboard link https://link-labs.atlassian.net/browse/NEX-1858
  // {
  //   title: 'sidebar-dashboard',
  //   toLink: '/dashboard',
  //   icon: 'mdi-home-outline',
  // },
  {
    title: 'sidebar-assets',
    active: false,
    toLink: '/assets',
    visible: false,
    icon: 'mdi-cube-outline',
  },
  {
    title: 'events',
    active: false,
    icon: 'mdi-file-document-outline',
    visible: false,
    subMenuItems: [
      {
        name: 'sidebar-settings-workflows',
        toLink: '/events/workflows',
        visible: false
      },
      {
        name: 'sidebar-settings-reports',
        toLink: '/events/reports',
        visible: false
      }
    ]
  },
  {
    title: 'system',
    active: false,
    icon: 'mdi-application-cog',
    visible: false,
    subMenuItems: [
      {
        name: 'sidebar-settings-health',
        toLink: '/system/health',
        id: 8,
      },
      {
        name: 'sidebar-supertag-settings',
        toLink: '/system/settings',
        id: 3
      },
      {
        name: 'sidebar-settings-search',
        toLink: '/system/search',
        id: 9
      },
    ]
  },
  {
    title: 'sidebar-opt7',
    active: false,
    icon: 'mdi-settings-outline',
    visible: false,
    subMenuItems: [
      {
        name: 'sidebar-settings-sites',
        id: 1,
        toLink:'/configuration/sites'
      },
      {
        name: 'sidebar-settings-basic-users',
        id: 2,
        toLink: '/configuration/users',
      },
      
      {
        name: 'sidebar-settings-theming',
        toLink: '/configuration/theming',
        id: 5,
      },
      
    ],
  },
  {
    title:'sidebar-org-select', 
    toLink:'/org-select',
    active: false,
    visible: false,
    icon:'mdi-office-building'
  },
  // {
  //   title:'sidebar-sla', 
  //   toLink:'/sla',
  //   active: false,
  //   visible: false,
  //   icon:'mdi-office-building'
  // },
  {
    title:'sidebar-help',
    toLink:'/help',
    active: false,
    visible: false,
    icon:'mdi-help-circle'
  }
];

const noOrgSidebarMenu = [
  {
    title: 'sidebar-org-select',
    toLink: '/org-select',
    active: false,
    visible: false,
    icon: 'mdi-office-building'
  },
  {
    title: 'sidebar-settings-search',
    toLink: '/search',
    active: false,
    visible: false,
    icon: 'mdi-card-search'
  }
];
export default {
  sidebarMenu,
  noOrgSidebarMenu
};
